import { ClosedDayResponse } from "../contracts/ClosedDayResponse";
import { ClosedDay } from "../models/ClosedDay";

/** Maps API closed-day responses to frontend ClosedDay models. */
export class ClosedDayResponseMapper {
  toClosedDay = (response: ClosedDayResponse): ClosedDay => ({
    id: response.id,
    date: response.date,
    reason: response.reason,
    dateCreated: response.dateCreated,
  });

  toClosedDays = (responses: ClosedDayResponse[]): ClosedDay[] =>
    responses.map(this.toClosedDay);
}
